import { isEmpty } from 'lodash';
import report from '../../../apis/report';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { rearrangeKeys } from './rearrageOutstandingTableColumnKey';

export const fetchOutstandingFeeReport = async (
  date: string,
  academicYear: string,
  status?: string
) => {
  const usersOutstandingFeeReport: any[] = [];
  const perPage = 500;
  let pageNo = 1;
  const BATCH_SIZE = 3;
  let hasMoreData = true;

  do {
    const pagePromises = [];
    for (let i = 0; i < BATCH_SIZE; i++) {
      pagePromises.push(
        report.fetchOutstandingFeeReport({
          date,
          academicYear,
          perPage,
          pageNo: pageNo + i,
          ...(status && { status })
        })
      );
    }

    const batchResults: any[] = await Promise.all(pagePromises);
    let foundEmpty = batchResults.some((result) => !result.hasMore);

    batchResults.forEach((result) => {
      if (!isEmpty(result.data)) {
        usersOutstandingFeeReport.push(...(result.data as any));
      }
    });

    if (foundEmpty) {
      hasMoreData = false;
    } else {
      pageNo += BATCH_SIZE;
    }
  } while (hasMoreData);
  return usersOutstandingFeeReport;
};

export const transformOutstandingFeeReportData = (
  outstandingFeeReportData: any
) => {
  let srNo = 0;
  const result: any = [];

  const allKeys = tableColumnUtils.extractUniqueKeys(outstandingFeeReportData);
  const rearrangedKeys = rearrangeKeys(allKeys);

  outstandingFeeReportData.forEach((data: any) => {
    const row: any = { 'Sr. No.': ++srNo };
    rearrangedKeys.forEach((key) => {
      row[key] = data[key] !== undefined ? data[key] : '';
    });
    result.push(row);
  });
  return result;
};
